export function parseWishlistSearch(search: Record<string, unknown>) {
  const text = (key: string) =>
    typeof search[key] === "string"
      ? (search[key] as string).trim().slice(0, 256)
      : "";
  const guid = (key: string) =>
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      text(key),
    ) && text(key) !== "00000000-0000-0000-0000-000000000000"
      ? text(key)
      : "";
  const integer = (key: string, fallback: number, max: number) => {
    const value = Number(search[key]);
    return Number.isInteger(value) && value > 0
      ? Math.min(value, max)
      : fallback;
  };
  return {
    customerQ: text("customerQ"),
    productQ: text("productQ"),
    customerId: guid("customerId"),
    productId: guid("productId"),
    availability: ["available", "unavailable"].includes(text("availability"))
      ? text("availability")
      : "",
    page: integer("page", 1, 1000000),
    pageSize: integer("pageSize", 25, 100),
  };
}
export type WishlistSearch = ReturnType<typeof parseWishlistSearch>;
